import React from 'react'
import { SanityTwoColumnsLeftSticky } from '../../../../../types/generated/graphql-types'
import { mapSanityTwoColumnsLeftStickyToTwoColumnsOneStickyProps } from '../../../../mapping/TwoColumnsLeftStickyMapper'
import { Nullable } from '../../../../types/nullable'
import { PortableTextBodyElement } from '../../../../utilities/blockContent'
import { BlockWithId } from '../../../../utilities/blockId'
import { TwoColumnsOneSticky } from '../../../blocks/TwoColumnsOneSticky'
import { MarketSection } from '../../../MarketSection'

export type TwoColumnsLeftStickySerializerProps = SanityTwoColumnsLeftSticky &
  BlockWithId & {
    allBlocks?: Nullable<PortableTextBodyElement>[]
    pageHasStickyMenu?: boolean
  }

export const TwoColumnsLeftStickySerializer = ({
  _key,
  allBlocks,
  id,
  pageHasStickyMenu,
  ...props
}: TwoColumnsLeftStickySerializerProps) => {
  let isOdd = true

  // Apply a background and mirrored content to every other continuous block of this type
  if (allBlocks) {
    for (const block of allBlocks) {
      if (block?._type === 'twoColumnsLeftSticky') {
        if (_key === block._key) {
          break
        } else {
          isOdd = !isOdd
        }
      } else {
        isOdd = true
      }
    }
  }

  return (
    <MarketSection applyGrid={false} id={id}>
      <TwoColumnsOneSticky
        {...mapSanityTwoColumnsLeftStickyToTwoColumnsOneStickyProps(props)}
        hasBackground={!isOdd}
        isMirrored={!isOdd}
        pageHasStickyMenu={pageHasStickyMenu}
      />
    </MarketSection>
  )
}
